import React from "react";
import Modal from "Utils/Modal";
import * as actions from "Actions";
import { connect } from "react-redux";
import classnames from "classnames";
import { Maintenance } from "Utils/SvgIcons";
import SerializedMaintainModal from "./serialized/MaintainModal";
import MaintainMultipleModal from "./serialized/MaintainMultipleModal";
import { FormattedDate } from 'react-intl';

const typeToPlural = {
  product: "items",
  accessory: "accessories",
  addOn: "purchases"
};

class NewMaintenancePop extends React.Component {
  state = {
    open: false,
    maintenanceRecord: {
      quantity: 0,
      lackNotes: "",
    }
  };

  toggleDialog = () => {
    this.setState({
      open: !this.state.open
    });
  };

  handleMaintenanceRecordChange = event => {
    const { name, value } = event.target;
    this.setState({
      maintenanceRecord: {
        ...this.state.maintenanceRecord,
        [name]: value
      }
    });
  };
  handleSerializedMaintenanceRefresh = () => {
    const { fetchProduct, inventoryProduct } = this.props;
    fetchProduct("product", inventoryProduct.token);
    this.setState({
      open: false
    });
  };

  handleAddMaintenance = () => {
    const { productType, inventoryProduct, addMaintenance } = this.props;
    const { maintenanceRecord } = this.state;

    // Validation
    if (
      maintenanceRecord.quantity <= 0 ||
      maintenanceRecord.quantity > inventoryProduct.rentableQuantity
    ) {
      this.props.setErrorMessage({
        field: "maintenanceQuantity",
        text: "Invalid maintenance quantity."
      });
    } else {
      addMaintenance(productType, inventoryProduct.token, maintenanceRecord);
      this.toggleDialog();
    }
  };

  renderMaintainModal() {
    const { inventoryProduct, productType, errors } = this.props;
    const { open, maintenanceRecord } = this.state;
    if (
      productType === "product" &&
      inventoryProduct.serializationStatus === "serialized"
    ) {
      return (
        <SerializedMaintainModal
          toggle={this.toggleDialog}
          open={open}
          product={inventoryProduct}
          onRefresh={this.handleSerializedMaintenanceRefresh}
        />
      );
    } else if (
      productType === "product" &&
      inventoryProduct.serializationStatus === "serialized_multiple"
    ) {
      return (
        <MaintainMultipleModal
          toggle={this.toggleDialog}
          open={open}
          product={inventoryProduct}
          onRefresh={this.handleSerializedMaintenanceRefresh}
        />
      );
    } else {
      return (
        <Modal
          open={open}
          toggle={this.toggleDialog}
          title="Add to Maintenance"
          actions={[
            <a
              id="submit_inventory"
              className="btn"
              onClick={this.handleAddMaintenance}
            >
              Submit And Update Inventory
            </a>,
            <a className="btn cancel" onClick={this.toggleDialog}>
              Cancel
            </a>
          ]}
        >
          <div className="form">
            <div className="fields">
              <p>How many {typeToPlural[productType]} need maintenance?</p>
              <input
                id="maintenance_quantity_input"
                name="quantity"
                style={{ width: 385 }}
                type="text"
                placeholder="0"
                className={classnames({
                  sm: true,
                  full: true,
                  error: errors.maintenanceQuantity
                })}
                value={maintenanceRecord.quantity}
                onChange={this.handleMaintenanceRecordChange}
              />

              <textarea
                name="lackNotes"
                style={{ width: 385 }}
                placeholder="Add notes here..."
                value={maintenanceRecord.lackNotes}
                onChange={this.handleMaintenanceRecordChange}
              />
            </div>
          </div>
        </Modal>
      );
    }
  }

  render() {
    const { inventoryProduct, version, displayMaintenanceRecords } = this.props;

    return (
      <div
        className={classnames('maintenance', {
          'without-border': version === 'v2'
        })}
      >
        {version === 'v1' &&
          <div>
            <p>
              <Maintenance />
              In maintenance:{" "}
              <span id="number_in_maintenance">
                {inventoryProduct.maintenanceQuantity}
              </span>
            </p>
            <a id="add_items_to_maintenance" onClick={this.toggleDialog}>
              Add items to maintenance
            </a>
          </div>
        }
        {version === 'v2' &&
          <div>
            <div className='display-flex'>
              <p>Items in maintenance:</p>
              <span className='font-bold-blue'>{inventoryProduct.maintenanceQuantity}</span>
            </div>
            <a className='toggle' onClick={this.toggleDialog}>
              <Maintenance />
              Create A Maintenance Ticket
            </a>
          </div>
        }
        {(displayMaintenanceRecords && !!inventoryProduct.maintenanceRecords?.length) && (
          <table>
            <tbody>
              {inventoryProduct.maintenanceRecords.map(maintenance => (
                <tr key={maintenance.id}>
                  <td>{maintenance.quantity}</td>
                  <td><label>{maintenance.token}</label></td>
                  <td>
                    <FormattedDate
                      value={maintenance.createdAt}
                      month='numeric'
                      year='numeric'
                      day='numeric'
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {this.renderMaintainModal()}
      </div>
    );
  }
}

NewMaintenancePop.defaultProps = {
  version: 'v1',
};

const mapStateToProps = state => {
  const { rental, loading } = state.rental;
  const { errors } = state.dashboard;
  return { rental, loading, errors };
};

export default connect(mapStateToProps, actions)(NewMaintenancePop);
